module.exports = __webpack_public_path__ + "static/media/banner_02.53b64a73.jpg";